import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { FaTimes, FaWhatsapp, FaInstagram, FaTwitter, FaFacebookF, FaLink } from 'react-icons/fa';
import '../styles/modals.css';
import './ShareModal.css';

const ShareModal = ({ isOpen, onClose, shareUrl, title, type = 'video' }) => {
    const [copied, setCopied] = useState(false);

    if (!isOpen) return null;

    const handleCopyLink = async () => {
        try {
            await navigator.clipboard.writeText(shareUrl);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    const handleWhatsApp = () => {
        const text = encodeURIComponent(`Check out this ${type}: ${title}\n${shareUrl}`);
        window.open(`https://wa.me/?text=${text}`, '_blank');
    };

    const handleInstagram = () => {
        // Instagram doesn't support direct sharing via URL, so we just copy the link
        handleCopyLink();
    };

    const handleTwitter = () => {
        const text = encodeURIComponent(`Check out this ${type}: ${title}`);
        const url = encodeURIComponent(shareUrl);
        window.open(`https://twitter.com/intent/tweet?text=${text}&url=${url}`, '_blank');
    };

    const handleFacebook = () => {
        const url = encodeURIComponent(shareUrl);
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank');
    };

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    if (typeof document === 'undefined') return null;

    /* Portal to body so position:fixed is viewport-relative (ancestor transform e.g. .post-card:hover breaks fixed) */
    return createPortal(
        <div className="share-modal-backdrop" onClick={handleBackdropClick} role="presentation">
            <div
                className="share-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="share-modal-title"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="share-modal-header">
                    <h3 id="share-modal-title" className="share-modal-title">SHARE {type.toUpperCase()}</h3>
                    <button type="button" className="share-modal-close" onClick={onClose} aria-label="Close share dialog">
                        <FaTimes />
                    </button>
                </div>
                <div className="share-modal-options">
                    <button type="button" className="share-option" onClick={handleWhatsApp}>
                        <FaWhatsapp className="share-icon whatsapp" />
                        <span>WhatsApp</span>
                    </button>
                    <div className="share-divider"></div>
                    <button type="button" className="share-option" onClick={handleInstagram}>
                        <FaInstagram className="share-icon instagram" />
                        <span>Instagram</span>
                    </button>
                    <div className="share-divider"></div>
                    <button type="button" className="share-option" onClick={handleTwitter}>
                        <FaTwitter className="share-icon twitter" />
                        <span>Twitter / X</span>
                    </button>
                    <div className="share-divider"></div>
                    <button type="button" className="share-option" onClick={handleFacebook}>
                        <FaFacebookF className="share-icon facebook" />
                        <span>Facebook</span>
                    </button>
                    <div className="share-divider"></div>
                    <button type="button" className="share-option" onClick={handleCopyLink}>
                        <FaLink className="share-icon copy-link" />
                        <span className={copied ? 'copied' : ''}>
                            {copied ? 'Copied!' : 'Copy Link'}
                        </span>
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ShareModal;
